/* eslint-disable import/prefer-default-export */
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import type { State } from '../configureStore'
import { Compliance as ActionTypes } from '../actionTypes'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import uuidv4 from 'uuid/v4'
import {
  IntentMgr,
  GroupRuleInfo
} from '@src/endpoints/services/intentMgr.service'
import { defaultHandleStatus } from '@src/endpoints/helpers'
import { defaultState } from '../reducers/rules/default.state'

// Action Creators
export type ActionTypes =
  | getRulesAction
  | requestGetRulesPendingAction
  | changeStateAction

export const changeState = ReduxHelpers.Common.Actions.changeState(
  ActionTypes.CHANGE_STATE,
  defaultState
)

type changeStateAction = ReturnType<typeof changeState>

const getRules = (
  rules: GroupRuleInfo[] = [],
  total = 0,
  failing = 0,
  passing = 0,
  title: string
) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.GET_COMPLIANCE_RULES, {
    rules,
    total,
    passing,
    failing,
    title
  })
type getRulesAction = ReturnType<typeof getRules>

const requestGetRulesPending = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(
    ActionTypes.GET_COMPLIANCE_RULES_PENDING,
    {
      isPending
    }
  )
type requestGetRulesPendingAction = ReturnType<typeof requestGetRulesPending>

export function onGetRules(suiteId: number) {
  return (dispatch: any, getState: () => State) => {
    const params = {
      'req_hdr.tid': uuidv4(),
      suite_id: suiteId
    }
    dispatch(
      changeState({
        isPending: true,
        list: [],
        totalCount: 0,
        failedCount: 0,
        passedCount: 0,
        title: ''
      })
    )
    IntentMgr.GetComplianceRules({ params })
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            requestGetRulesPending(false)
          },
          true
        )
      )
      .then(response => {
        const { rules, total_tests, failing_tests, passing_tests, suite } =
          response
        dispatch(
          getRules(rules, total_tests, failing_tests, passing_tests, suite)
        )
      })
      .catch(ex => {
        requestGetRulesPending(false)
        return ex
      })
  }
}
